import founderImage from "../assets/vision.jpg";
import supplyImage from "../assets/kitchen_appliances.jpg";
import cleaningImage from "../assets/window_cleaning.jpg";
import headerBg from "../assets/bedroom_cleaning.jpg";

const teamMembers = [
  "Founder: Ms Rustica Sanga",
  "General Manager: Mr Paul Sanga",
  "Management support in business administration, procurement management, and human resources",
];

const businessAreas = [
  "Importation and supply of children products and wears, diapers, women pads, clothing, uniforms, and beddings",
  "Kitchen and home appliances, electrical materials, consumables, office equipment, furniture, and fittings",
  "Residential cleaning including kitchens, living rooms, bathrooms, and bedrooms",
  "Deep cleaning including cabinets, upholstery, ovens, ceiling fan blades, baseboards, and detailed surface care",
];

export default function AboutUsContent() {
  return (
    <>
      <section className="page-hero page-hero-about" style={{backgroundImage: `url(${headerBg})`, backgroundSize: 'cover', backgroundPosition: 'center', width: "100%", height: "100%", objectFit: "cover"}}>
        <div className="container">
          <div className="page-hero-content">
            <h1 data-aos= "fade-right" data-aos-delay="100">We combine supply reliability with service discipline.</h1>
            <p data-aos= "fade-up" data-aos-delay="200">
              MS Universal Distributors exists to make quality products and
              dependable services more accessible, affordable, and timely for a
              growing customer base.
            </p>
          </div>
        </div>
      </section>

      <section className="section-shell">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-lg-6">
              <div className="editorial-panel h-100">
                <h2 data-aos="fade-up" data-aos-delay="100">About Us</h2>
                <p data-aos="fade-up" data-aos-delay="200">
                  Our business has grown by focusing on quality, responsiveness,
                  and a practical understanding of what customers need every day.
                  We serve households, institutions, and workplaces with a broad
                  product range and professional cleaning support.
                </p>
                <p data-aos="fade-up" data-aos-delay="200">
                  The company&apos;s milestone is clear: continued growth through
                  more supply points, better reach, and service excellence built
                  on affordability and consistency.
                </p>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="feature-image-card h-100">
                <img src={founderImage} alt="MS Universal leadership and vision" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-shell section-soft">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-6">
              <div className="editorial-panel h-100">
                <h2 data-aos="fade-right" data-aos-delay="100">What we do</h2>
                <div className="bullet-grid">
                  {businessAreas.map((item) => (
                    <div key={item} className="bullet-grid-item" data-aos="fade-up" data-aos-delay="200">
                      <span />
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="col-lg-6" >
              <div className="row g-4">
                <div className="col-12" data-aos="fade-up" data-aos-delay="100">
                  <div className="feature-image-card">
                    <img src={supplyImage} alt="MS Universal supply services" />
                  </div>
                </div>
                <div className="col-sm-6" data-aos="fade-up" data-aos-delay="200">
                  <div className="vision-panel h-100" >
                    <h3>Vision</h3>
                    <p>
                      To become a solution to our customers by supplying goods and
                      services that are affordable and quality.
                    </p>
                  </div>
                </div>
                <div className="col-sm-6" data-aos="fade-up" data-aos-delay="300">
                  <div className="vision-panel h-100">
                    <h3>Mission</h3>
                    <p>
                      To provide quality products and services timely and
                      affordable.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-shell">
        <div className="container">
          <div className="row g-4 align-items-stretch">
            <div className="col-lg-5" data-aos="fade-up" data-aos-delay="100">
              <div className="feature-image-card h-100">
                <img src={cleaningImage} alt="MS Universal cleaning operations" />
              </div>
            </div>
            <div className="col-lg-7">
              <div className="editorial-panel h-100">
                <h2 data-aos="fade-left" data-aos-delay="100">Leadership, market growth, and goals</h2>
                <p data-aos="fade-up" data-aos-delay="200">
                  We have a valued team led by Founder Ms Rustica Sanga and
                  General Manager Mr Paul Sanga, supported by professionals in
                  accounts, procurement, administration, and human resources.
                </p>
                <p data-aos="fade-up" data-aos-delay="300">
                  Due to quality products and services, the business has been
                  expanding and increasing customer numbers every year, supported
                  by timely deliveries and dependable client service.
                </p>

                <div className="row g-3 mt-2">
                  <div className="col-md-6" data-aos="fade-up" data-aos-delay="400">
                    <div className="mini-panel h-100">
                      <strong>Our Team</strong>
                      {teamMembers.map((member) => (
                        <p key={member}>{member}</p>
                      ))}
                    </div>
                  </div>
                  <div className="col-md-6" data-aos="fade-up" data-aos-delay="400">
                    <div className="mini-panel h-100">
                      <strong>Goals</strong>
                      <p>Leading business across all our supply categories.</p>
                      <p>Fulfillment through efficiency and customer satisfaction.</p>
                      <p>Profitable expansion with consistency in quality and service.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
